export default {
    pending: 'pending',
    inProgress: 'inProgress',
    completed: 'completed',
    cancelled: 'cancelled',
    failed: 'failed'
}
